<template>
  <div
    class="border-2 border-dashed rounded-xl p-8 text-center transition-all duration-300 cursor-pointer w-full h-full flex items-center justify-center"
    :class="isDragging ? 'border-primary-400 bg-primary-900/30' : 'border-gray-600 hover:border-gray-500'"
    @dragover.prevent="handleDragOver"
    @dragleave.prevent="handleDragLeave"
    @drop.prevent="handleDrop"
    @click="triggerInput"
  >
    <input
      ref="inputRef"
      type="file"
      accept="image/*"
      class="hidden"
      @change="handleFileChange"
    >

    <div class="space-y-4">
      <div class="w-16 h-16 bg-gradient-to-br from-primary-500/20 to-indigo-500/20 rounded-full flex items-center justify-center mx-auto">
        <PhotoIcon class="w-8 h-8 text-primary-400" />
      </div>

      <div>
        <p class="text-gray-200 font-medium">Click to upload or drag and drop</p>
        <p class="text-gray-400 text-sm mt-1">Supports JPG, PNG, WebP and more</p>
      </div>

      <div class="flex items-center justify-center gap-2 text-xs text-gray-400">
        <span class="px-2 py-1 bg-gray-700/50 rounded">Max 20MB</span>
        <span class="px-2 py-1 bg-gray-700/50 rounded">Any size</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { PhotoIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits(['upload'])

const inputRef = ref(null)
const isDragging = ref(false)

const triggerInput = () => {
  inputRef.value?.click()
}

const handleDragOver = () => {
  isDragging.value = true
}

const handleDragLeave = () => {
  isDragging.value = false
}

const handleDrop = (e) => {
  isDragging.value = false
  const file = e.dataTransfer.files[0]
  processFile(file)
}

const handleFileChange = (e) => {
  const file = e.target.files[0]
  processFile(file)
}

const processFile = (file) => {
  if (!file) return
  
  if (!file.type.startsWith('image/')) {
    alert('Please upload an image file')
    return
  }
  
  if (file.size > 20 * 1024 * 1024) {
    alert('Image size must not exceed 20MB')
    return
  }
  
  const reader = new FileReader()
  reader.onload = (e) => {
    emit('upload', {
      data: e.target.result,
      name: file.name
    })
  }
  reader.readAsDataURL(file)
}
</script>
